import React, { useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';
import SuccessModal from './SuccessModal';
const API_URL = process.env.REACT_APP_API_URL;
// Bu bileşen, AllJobsPage'den gelen prop'ları kullanarak çalışır.
const JobDetails = ({ job, t, onJobUpdate, onNewFileAdded, onFileDeleted, eligibleTranslators, selectedTranslator, onTranslatorSelect, onAssign, fees, onLanguageChange, availableLanguages }) => {

  const [currentLangs, setCurrentLangs] = useState({ source: job.source_lang, target: Array.isArray(job.target_langs) ? job.target_langs[0] || '' : '' });
  const [isUploading, setIsUploading] = useState(false);
  const { token } = useAuth();

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const handleLangChange = (field, value) => {
      const newLangs = {...currentLangs, [field]: value};
      setCurrentLangs(newLangs);
      onLanguageChange(job.id, newLangs.source, [newLangs.target]);
  };
  
  const handleFileSelectAndUpload = (e) => {
    const file = e.target.files[0];
    if (file) { handleUpload(file); }
  };

  const handleUpload = async (file) => {
    setIsUploading(true);
    const formData = new FormData();
    formData.append('sourceFile', file);
    try {
        const response = await fetch(`${API_URL}/api/support/jobs/${job.id}/add-source-file`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: formData
        });
        if (!response.ok) throw new Error(t('error_file_upload'));
        const newFileData = await response.json();
        onNewFileAdded(newFileData);
    } catch (err) {
        alert(err.message);
    } finally {
        setIsUploading(false);
    }
  };
	
  const openDeleteModal = (file) => {
      setFileToDelete(file);
      setIsDeleteModalOpen(true);
  };
  
  const confirmDeleteFile = () => {
    if (!fileToDelete) return;
    // DÜZELTME: Kelime sayısı da gönderiliyor
    handleDeleteFileApi(fileToDelete.id, fileToDelete.word_count);
    setIsDeleteModalOpen(false);
    setFileToDelete(null);
  };

 const handleDeleteFileApi = async (fileId, wordCount) => {
    try {
        const response = await fetch(`${API_URL}/api/support/jobs/${job.id}/source-file/${fileId}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
        const data = await response.json();
        if (!response.ok) throw new Error(t(data.messageKey) || t('error_file_delete'));
        onFileDeleted(fileId, wordCount); // DÜZELTME: Kelime sayısını da yukarı gönder
        setModalMessage(t(data.messageKey || 'success_file_deleted'));
        setIsSuccessModalOpen(true);

    } catch (err) {
        alert(err.message);
    }
  };
  const anyExtraService = job.requires_dtp || job.requires_shipping || job.requires_notary;
  const [isEditingTranslatorDeadline, setIsEditingTranslatorDeadline] = useState(false);
  const [newTranslatorDeadline, setNewTranslatorDeadline] = useState('');
const fileInput = useRef(null);
  // Düzenleme modunu açan handler
  const handleEditDeadlineClick = () => {
    if (job && job.translator_deadline) {
        const localDate = new Date(job.translator_deadline);
        localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
        setNewTranslatorDeadline(localDate.toISOString().slice(0, 16));
    } else {
        // Eğer deadline yoksa, şimdiki zamandan 24 saat sonrasını varsayılan yap
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setMinutes(tomorrow.getMinutes() - tomorrow.getTimezoneOffset());
        setNewTranslatorDeadline(tomorrow.toISOString().slice(0, 16));
    }
    setIsEditingTranslatorDeadline(true);
  };

  // Yeni deadline'ı backend'e gönderen handler
  const handleUpdateTranslatorDeadline = async () => {
    if (!newTranslatorDeadline) return;
    try {
        const response = await fetch(`${API_URL}/api/support/jobs/${job.id}/translator-deadline`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            body: JSON.stringify({ newDeadline: new Date(newTranslatorDeadline).toISOString() })
        });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(t(data.messageKey) || t('error_deadline_update'));
        }
        
        // Arayüzü anında güncellemek için ana bileşeni uyar
        onJobUpdate({ ...job, translator_deadline: new Date(newTranslatorDeadline).toISOString() });
        setIsEditingTranslatorDeadline(false);
        setModalMessage(t(data.messageKey || 'success_deadline_updated'));
        setIsSuccessModalOpen(true);


    } catch (err) {
        alert(err.message);
    }
  };
  return (
    <>
      <div className="job-card-details">
        <div className="detail-columns">
          <div className="detail-column">
		   <div className="info-item-stacked">
                <strong>{t('word_count')}: </strong>
                <span>{job.word_count}</span>
            </div>
            <div className="info-item-stacked">
                <strong>{t('expertise_area')}: </strong>
                <span>{t(job.expertise)}</span>
            </div>
            <div className="info-item-stacked">
                <strong>{t('deadline_check')}: </strong>
                <span>{new Date(job.deadline).toLocaleString()}</span>
            </div>
			<div className="info-item-stacked">
                <strong>{t('translator_deadline')}: </strong>
                {isEditingTranslatorDeadline ? (
                    <div className="deadline-editor">
                        <input type="datetime-local" value={newTranslatorDeadline} onChange={(e) => setNewTranslatorDeadline(e.target.value)} />
                        <button onClick={handleUpdateTranslatorDeadline} className="save-deadline-btn"><i className="fas fa-check"></i></button>
                        <button onClick={() => setIsEditingTranslatorDeadline(false)} className="cancel-deadline-btn"><i className="fas fa-times"></i></button>
                    </div>
                ) : (
                    <span onClick={handleEditDeadlineClick} className="editable-deadline" title={t('click_to_edit')}>
                        {job.translator_deadline ? new Date(job.translator_deadline).toLocaleString() : t('not_set', 'Belirlenmedi')}
                    </span>
                )}
            </div>
             <div className="info-item-stacked">
                <strong>{t('customer_timezone')}: </strong>
                <span>{job.customer_timezone}</span>
            </div>
            <div className="info-item-stacked">
                <strong>{t('delivery_speed')}: </strong>
                <span>{t(job.delivery_speed === 'fast' ? 'fast_delivery' : 'standard_delivery')}</span>
            </div>
            <div className="info-item-stacked">
                <strong>{t('order_class')}: </strong>
                <span>{t(job.translator_type)}</span>
            </div>
           <div className="extra-services-details-list">
                            <strong>{t('extra_services')}:</strong>
                            {anyExtraService ? (
                                <ul>
                                    {job.requires_dtp && <li>{t('dtp_service')}</li>}
                                    {job.requires_shipping && <li>{t('shipping_service')}</li>}
                                    {job.requires_notary && <li>{t('notary_service')}</li>}
                                </ul>
                            ) : ( <span>{t('none')}</span> )}
                        </div>
        
            <div><strong>{t('source_documents')}: </strong>
              {job.files && job.files.filter(f => f.file_type === 'source').length > 0 ? (
                <ul className="source-file-list">
                  {job.files.filter(f => f.file_type === 'source').map(file => (
                    <li key={file.id}>
                      <a href={`${API_URL}/${file.filepath}`} download={file.original_filename}><i className="fas fa-file-alt"></i> {file.original_filename}</a>
                      <button onClick={() => openDeleteModal(file)} className="delete-file-btn" title={t('delete')}><i className="fas fa-trash-alt"></i></button>
                    </li>
                  ))}
                </ul>
              ) : ( <span className="no-files-text">{t('no_source_files_found')}</span> )}
              <div className="add-file-container">
                {/* DÜZELTME 3: Artık doğru ref'i kullanıyor */}
                <input type="file" ref={fileInput} style={{ display: 'none' }} id={`add-file-${job.id}`} onChange={handleFileSelectAndUpload} />
                <button className="add-file-btn" onClick={() => fileInput.current.click()}>
                    {isUploading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-plus"></i>}
                    {t('add_source_file')}
                </button>
              </div>
            </div>
          </div>

          <div className="detail-column">
              <h4>{t('edit_languages')}</h4>
              <div className="language-edit-controls">
                  <select value={currentLangs.source} onChange={(e) => handleLangChange('source', e.target.value)}>
                      {availableLanguages.map(lang => <option key={lang.value} value={lang.value}>{lang.label}</option>)}
                  </select>
                  <span>→</span>
                  <select value={currentLangs.target} onChange={(e) => handleLangChange('target', e.target.value)}>
                      {availableLanguages.map(lang => <option key={lang.value} value={lang.value}>{lang.label}</option>)}
                  </select>
              </div>
              <h4 style={{marginTop: '20px'}}>{t('assign_directly')}</h4>
              {eligibleTranslators.loading ? <p><i className="fas fa-spinner fa-spin"></i></p> : 
               eligibleTranslators.error ? <p className="error">{eligibleTranslators.error}</p> :
               eligibleTranslators.data.length === 0 ? <p>{t('no_eligible_translators')}</p> : (
                <div className="assign-controls">
                  <select value={selectedTranslator || ''} onChange={(e) => onTranslatorSelect(e.target.value)}>
                    <option value="">{t('select_translator')}</option>
                    {eligibleTranslators.data.map(translator => (<option key={translator.id} value={translator.id}>{translator.first_name} {translator.last_name}</option>))}
                  </select>
                  <button onClick={onAssign} disabled={!selectedTranslator || !fees[job.id]} className="assign-btn">{t('assign_btn')}</button>
                </div>
              )}
          </div>
        </div>
      </div>
      
      <ConfirmationModal 
           isOpen={isDeleteModalOpen}
           onClose={() => setIsDeleteModalOpen(false)}
           onConfirm={confirmDeleteFile}
           title={t('confirm_delete_file_title')}
           message={t('confirm_delete_file_message', { fileName: fileToDelete?.original_filename })}
      />
      <SuccessModal
        isOpen={isSuccessModalOpen}
        onClose={() => setIsSuccessModalOpen(false)}
        title={t('success')}
        message={modalMessage}
      />
    </> // DÜZELTME 2: Ana Fragment burada bitiyor
  );
};
export default JobDetails;